/**
 * OutreachActivitiesPage
 *
 * Single tab landing for the Activity Tracking nav entry. Toggles between
 * MyOutreachActivities (list) and OutreachActivityForm (entry). Promotora-
 * scoping is enforced server-side, so the list view is correct for every
 * role without conditional rendering here.
 */

import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAppTranslation } from '@/contexts/TranslationContext';
import { MyOutreachActivities } from './MyOutreachActivities';
import { OutreachActivityForm } from './OutreachActivityForm';

type Mode = 'list' | 'create';

export const OutreachActivitiesPage: React.FC = () => {
  const { t } = useAppTranslation();
  const [mode, setMode] = useState<Mode>('list');
  const [reloadKey, setReloadKey] = useState(0);

  if (mode === 'create') {
    return (
      <div className="p-4">
        <div className="max-w-4xl mx-auto mb-2">
          <Button variant="ghost" size="sm" onClick={() => setMode('list')}>
            <ChevronLeft className="w-4 h-4 mr-1" />
            {t('outreach.back_to_activities', 'Back to activities')}
          </Button>
        </div>
        <OutreachActivityForm
          onCancel={() => setMode('list')}
          onSubmitted={() => {
            setReloadKey((k) => k + 1);
            // Briefly hold on success screen, then return to list
            setTimeout(() => setMode('list'), 1500);
          }}
        />
      </div>
    );
  }

  return (
    <MyOutreachActivities key={reloadKey} onCreateClick={() => setMode('create')} />
  );
};

export default OutreachActivitiesPage;
